"use client";
import Button from "@marginly/ui/components/button";
import { useState } from "react";
import { useAccount } from "wagmi";

import { usePersonalTickets } from "@/components/raffle/hooks";
import { WonTicketsModal } from "@/components/raffle/results/won-tickets-modal/won-tickets-modal";
import { MAIN_APP_URL } from "@/constants/links";
import { useMemberInfo } from "@/contexts/contest-member-info/hooks";
import { formatNum } from "@/lp/util/format";
import { trackLaunchAppClick } from "@/util/tracking";

import { useRegistration } from "./use-registration";
import { useTotalMemberFetch } from "./use-total-member-fetch";

export function RegistrationButton() {
  const { address } = useAccount();

  const { totalMember } = useTotalMemberFetch();
  const { loaded, refCode } = useMemberInfo();
  const { registration } = useRegistration();

  const personalTickets = usePersonalTickets(address);
  const wonAmount = personalTickets.reduce(
    (sum, ticket) => sum + ticket.winAmountUsd,
    0,
  );
  const [personalModalOpen, setPersonalModalOpen] = useState(false);

  if (wonAmount) {
    return (
      <>
        <Button
          fit
          lg
          onClick={() => {
            setPersonalModalOpen(true);
          }}
        >
          You Won ${formatNum(wonAmount)}
        </Button>
        {personalModalOpen && (
          <WonTicketsModal
            tickets={personalTickets}
            onHide={() => {
              setPersonalModalOpen(false);
            }}
          />
        )}
      </>
    );
  }

  if (refCode) {
    return (
      <a href={MAIN_APP_URL} onClick={trackLaunchAppClick}>
        <Button fit lg>
          Go to app
        </Button>
      </a>
    );
  }
  if (address && !loaded) {
    return null;
  }
  if (totalMember) {
    return (
      <Button fit lg onClick={registration}>
        Join {totalMember} Participants
      </Button>
    );
  }
  return null;
}
